import { eu_taxonomy_datasource_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateEuTaxonomyDatasourceEnum = (enumValue: eu_taxonomy_datasource_enum) => {
  switch (enumValue) {
    case eu_taxonomy_datasource_enum.DEFAULT_INDEX:
      return <Trans i18nKey="Enum_EuTaxonomyDatasourceEnum-DEFAULT_INDEX" />;
    case eu_taxonomy_datasource_enum.DREES_UND_SOMMER:
      return <Trans i18nKey="Enum_EuTaxonomyDatasourceEnum-DREES_UND_SOMMER" />;
  }
};

export const translateEuTaxonomyDatasourceEnum_dynamic = (enumValue: eu_taxonomy_datasource_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case eu_taxonomy_datasource_enum.DEFAULT_INDEX:
      return t('Enum_EuTaxonomyDatasourceEnum-DEFAULT_INDEX');
    case eu_taxonomy_datasource_enum.DREES_UND_SOMMER:
      return t('Enum_EuTaxonomyDatasourceEnum-DREES_UND_SOMMER');
  }
};
